module.exports = __webpack_public_path__ + "assets/img/perinatal-putin-m.e36e207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/perinatal-putin-m.jpg
// module id = SF5G
// module chunks = 0